import { Component, OnInit, HostBinding } from '@angular/core';
import { Router } from '@angular/router';
import { MetaService } from 'app/services/meta.service';

@Component({
  selector: 'contact-block',
  templateUrl: './contact-block.component.html',
  standalone: false,
})
export class ContactBlockComponent implements OnInit {
  title;
  description;
  links: [] = [];

  @HostBinding('class.-hideCard') isContactInfoAbsent = false;

  constructor(public router: Router, private metaService: MetaService) {}

  ngOnInit(): void {
    this.metaService.metadata.subscribe((meta) => {
      if (meta && meta['contact']) {
        this.title = meta['contact']['title'] ? meta['contact']['title'] : null;
        this.description = meta['contact']['description'] ? meta['contact']['description'] : null;
        this.links = meta['contact']['links'] && meta['contact']['links'].length > 0 ? meta['contact']['links'] : [];

        if (this.title === null && this.description === null && this.links.length === 0) {
          this.isContactInfoAbsent = true;
        }
      }

      if (meta && !meta['contact']) {
        this.isContactInfoAbsent = true;
      }
    });
  }
}
